import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Cpu, Search, ShieldCheck, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Navbar() {
  const { user } = useAuth();
  const isAdmin = user && user.role === "admin";

  const linkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-slate-900" : "text-slate-600 hover:text-slate-900"}`;

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 border-b border-slate-200 bg-white/85 backdrop-blur-md"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 group">
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-slate-900 text-white shadow-sm group-hover:bg-blue-600 transition-colors">
            <Cpu className="w-5 h-5" strokeWidth={2.2} />
          </span>
          <span className="font-display text-lg font-bold tracking-tight text-slate-900">
            Mymi<span className="text-blue-600">·</span>Global
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Home</NavLink>
          <NavLink to="/inventory" className={linkCls} data-testid="nav-inventory">Inventory</NavLink>
          <NavLink to="/contact" className={linkCls} data-testid="nav-contact">Contact</NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/inventory"
            data-testid="nav-search-cta"
            className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-full border border-slate-200 text-sm text-slate-600 hover:border-slate-300 hover:text-slate-900 transition-colors"
          >
            <Search className="w-4 h-4" /> Shop inventory
          </Link>
          {isAdmin ? (
            <Link
              to="/admin"
              data-testid="nav-admin-dashboard"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 text-white text-sm font-medium hover:bg-blue-600 transition-colors"
            >
              <ShieldCheck className="w-4 h-4" /> Dashboard
            </Link>
          ) : (
            <Link
              to="/admin/login"
              data-testid="nav-admin-login"
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-900 text-white text-sm font-medium hover:bg-blue-600 transition-colors"
            >
              <User className="w-4 h-4" /> Admin
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
